import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { withAccount } from '../../../../components/AccountContext';
import AssessmentList from './SuperLinkAssessmentList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../../utils/UrlUtil';

const LIST_QUERY = gql`
  query getSuperlinkAssessments(
    $accountId: ID!
    $sId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: AssessmentFilter
    $sort: AssessmentSortSpecifier
  ) {
    account(id: $accountId) {
      id
      superLink(id: $sId) {
        id
        assessments(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          totalCount
          indexFrom
          indexTo
          edges {
            node {
              id
              locale
              status
              createdOn
              updatedOn
              respondent {
                id
                firstName
                lastName
              }
              template {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

class AssessmentListContainer extends Component {
  static propTypes = {
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    currentAccount: PropTypes.number.isRequired,
  };

  render() {
    const {
      currentAccount, location, translatedTags, match,
    } = this.props;
    const { superLinkId } = match.params;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sId: superLinkId,
      sort: params.sort,
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account && data.account.superLink && data.account.superLink.assessments
            ? data.account.superLink.assessments
            : emptyConnection();

          return (
            <Fragment>
              <AssessmentList
                connection={connection}
                currentAccount={currentAccount}
                superLinkId={superLinkId}
                translatedTags={translatedTags}
                loading={loading}
              />
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

AssessmentListContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default withRouter(injectIntl(connect(mapState)(withAccount(AssessmentListContainer))));
